import React from 'react';
import {DirView} from '../../services/openapi/models/DirView';
import {AccessibleDocument} from '../../services/openapi';

export interface I_breadcrumb {
  id: string;
  name: string;
}

interface ContextViewFileListInterface {
  curr_dir_id: string | undefined;
  root_id: string | undefined;
  breadcrumbs: I_breadcrumb[];
  curr_dir_view: DirView | {};
  accessible_elements: Record<string, AccessibleDocument>;
  user_specific: boolean | undefined;
  loading_dir: boolean;
  error: string | null;
  update_accessible_elements: () => void;
  navigate_to_dir: (id: string) => void;
  navigate_to_page_root: () => void;
  navigate_up: () => void;
  update_dir_view: (id: string | undefined) => void;
  invalidate_dir_cache: () => void;
}

const defaultContext: ContextViewFileListInterface = {
  curr_dir_id: undefined,
  root_id: '',
  breadcrumbs: [],
  curr_dir_view: {},
  accessible_elements: {},
  user_specific: true,
  loading_dir: false,
  error: null,
  update_accessible_elements: () => {},
  navigate_to_dir: () => {},
  navigate_to_page_root: () => {},
  navigate_up: () => {},
  update_dir_view: () => {},
  invalidate_dir_cache: () => {},
};

const ContextViewFileList = React.createContext<ContextViewFileListInterface>(defaultContext);

export default ContextViewFileList;
